// Perfis da conta (identity/domain.User.Role no backend). O superadmin tem tudo o que o
// admin tem e, além disso, altera o perfil de outras contas.
export const ROLES = {
  user: "user",
  admin: "admin",
  superadmin: "superadmin",
};

export const isAdmin = (user) => user?.role === ROLES.admin || user?.role === ROLES.superadmin;

export const isSuperAdmin = (user) => user?.role === ROLES.superadmin;
